module.exports = __webpack_public_path__ + "static/media/globe.06ec181a.svg";